export const getPredefinedFeatures = (): Record<string, any> => ({
	isReadyAssessEnabled:
		process.env.REACT_APP_FEATURE_IS_READY_ASSESS_ENABLED === 'true',
	isReportingLibraryEnabled:
		process.env.REACT_APP_FEATURE_REPORTING_LIBRARY === 'true',
	isRiskReferenceTaxonomyEnabled:
		process.env.REACT_APP_FEATURE_RISK_REFERENCE_TAXONOMY === 'true',
	isRegulationChangeEnabled:
		process.env.REACT_APP_FEATURE_REGULATION_CHANGE === 'true',
	isChangeEngineEnabled: process.env.REACT_APP_FEATURE_CHANGE_ENGINE === 'true',
	isRequirementInventoryEnabled:
		process.env.REACT_APP_FEATURE_REGULATION_INVENTORY === 'true',
	isRiskChangeEnabled: process.env.REACT_APP_FEATURE_RISK_CHANGE === 'true',
	isTestingAndMonitoringEnabled:
		process.env.REACT_APP_FEATURE_TESTING_AND_MONITORING === 'true',
	isAiModelsEnabled: process.env.REACT_APP_FEATURE_AI_MODELS === 'true',
	isAiSimulationAndExperimentationEnabled:
		process.env.REACT_APP_FEATURE_AI_SIMULATION_AND_EXPERIMENTATION === 'true',
	isPrciCreationEnabled: process.env.REACT_APP_FEATURE_PRCI_CREATION === 'true',
	isPrciGovernanceEnabled:
		process.env.REACT_APP_FEATURE_PRCI_GOVERNANCE === 'true',
	isIntegrationsEnabled: process.env.REACT_APP_FEATURE_INTEGRATIONS === 'true',
	isHorizonScanningEnabled:
		process.env.REACT_APP_FEATURE_HORIZON_SCANNING === 'true',
	isDataIngestionEnabled:
		process.env.REACT_APP_FEATURE_DATA_INGESTION === 'true',
	isRiskGptEnabled: process.env.REACT_APP_FEATURE_RISK_GPT === 'true',
	isManagementEnabled: process.env.REACT_APP_FEATURE_MANAGEMENT === 'true',
	isMultiLanguageEnabled:
		process.env.REACT_APP_FEATURE_MULTI_LANGUAGE === 'true',
	isAdminOverviewEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_OVERVIEW === 'true',
	isAdminUserManagementEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_USER_MANAGEMENT === 'true',
	isAdminPermissionsEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_PERMISSIONS === 'true',
	isAdminQueueWorkflowEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_QUEUE_WORKFLOW === 'true',
	isAdminSystemEnabled: process.env.REACT_APP_FEATURE_ADMIN_SYSTEM === 'true',
	isAdminNotificationsEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_NOTIFICATIONS === 'true',
	isAdminSecurityEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_SECURITY === 'true',
	isAdminJobSchedulerEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_JOB_SCHEDULER === 'true',
	isAdminEscalationEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_ESCALATION === 'true',
	isAdminChecklistEnabled:
		process.env.REACT_APP_FEATURE_ADMIN_CHECKLIST === 'true',
	isDataIngestionAdvanceFilterEnabled:
		process.env.REACT_APP_FEATURE_DATA_INGESTION_ADVANCE_FILTER === 'true',
	isRegulationGraphEnabled:
		process.env.REACT_APP_FEATURE_REGULATION_GRAPH === 'true',
	isRegulationChangeViewByDropDownEnabled:
		process.env.REACT_APP_FEATURE_REGULATION_CHANGE_VIEWBY_DROPDOWN === 'true',
	isControlDeDuplicationFilterEnabled:
		process.env.REACT_APP_FEATURE_CONTROL_DEDUPLICATION_FILTER === 'true',
	isHomePageSearchEnabled:
		process.env.REACT_APP_FEATURE_HOME_PAGE_SEARCH === 'true',
	isHomePageFilterEnabled:
		process.env.REACT_APP_FEATURE_HOME_PAGE_FILTER === 'true',
	isNodeTypeFilterEnabled:
		process.env.REACT_APP_FEATURE_TAXONOMY_DETAIL_FILTER_NODE_TYPE === 'true',
	isRiskLevelFilterEnabled:
		process.env.REACT_APP_FEATURE_TAXONOMY_DETAIL_FILTER_RISK_LEVEL_TYPE ===
		'true',
	isNotableChangesEnabled:
		process.env.REACT_APP_FEATURE_TAXONOMY_DETAIL_NOTABLE_CHANGES === 'true',
	isAILandingPageSettingEnabled:
		process.env.REACT_APP_AI_LANDING_PAGE_SETTING_BUTTON === 'true',
	isAILandingPageSectionSearchEnabled:
		process.env.REACT_APP_AI_LANDING_PAGE_SECTION_SEARCH === 'true',
	isAILandingPageSectionSortEnabled:
		process.env.REACT_APP_AI_LANDING_PAGE_SECTION_SORT === 'true',
	isAILandingPageSectionFilterEnabled:
		process.env.REACT_APP_AI_LANDING_PAGE_SECTION_FILTER === 'true',
	isAILandingPageSectionQATabEnabled:
		process.env.REACT_APP_FEATURE_AI_LANDING_PAGE_SECTION_QA_TAB === 'true',
	aiSummaryMaxCharLimit: process.env.REACT_APP_FEATURE_AI_SUMMARY_CHAR_MAX_LIMIT
		? process.env.REACT_APP_FEATURE_AI_SUMMARY_CHAR_MAX_LIMIT
		: 131070,
	isAskLinkFeedBackEnabled:
		process.env.REACT_APP_FEATURE_ASKLINK_FEEDBACK === 'true',
	isThemeEnabled: process.env.REACT_APP_FEATURE_THEME === 'true',
	isReportingLibrarySearchEnabled:
		process.env.REACT_APP_FEATURE_REPORTING_SEARCH === 'true',
	isReportingLibraryFilterEnabled:
		process.env.REACT_APP_FEATURE_REPORTING_FILTER === 'true',
	isReportingLibraryAddReportEnabled:
		process.env.REACT_APP_FEATURE_REPORTING_ADD_REPORT === 'true',
	isDataDogEnabled: process.env.REACT_APP_FEATURE_DATADOG_ENABLED === 'true',
	isTrialPeriodEnabled:
		process.env.REACT_APP_FEATURE_IS_TRIAL_PERIOD_ENABLED === 'true',
	isTermsAndConditionEnabled:
		process.env.REACT_APP_FEATURE_IS_TERMS_AND_CONDITION_ENABLED === 'true',
	isAskRiskLinkUploadFileEnabled:
		process.env.REACT_APP_FEATURE_ASK_RISK_LINK_UPLOAD === 'true',
});
